// ⚠️ MIRROR / DRIFT-GUARDED. The stage MODEL here must match the backend's
// app/ui/stage.ts (single-visible). Field changes MUST be reflected in
// ./stage-contract.json + ported to the backend; stage-contract.test.ts enforces it.
/**
 * stage — Stage state types for the shared VN player, lifted from the
 * production single-visible model (moonshort-backend/app/ui/stage.ts).
 *
 * Single-visible model: at most ONE character portrait is on screen at a time
 * (`visible`), plus a `lastPose` memory so a dialogue line for an off-screen
 * character can implicitly re-show its last sprite. This REPLACES the older
 * 3-slot (charLeft/charCenter/charRight) model.
 *
 * `buildStageFromSnapshot` from the backend is intentionally NOT lifted here:
 * the in-IDE / web previews always replay from episode start (no DB session),
 * so the session-api dependency stays backend-only.
 *
 * IDE-only additions on top of the online model (missing-asset coverage):
 *   - StageState.bgName? / bgMissing?
 *   - StageVisibleChar.missing? / look?
 * These are optional, so a backend importer that never sets them is unaffected.
 */
export const EMPTY_STAGE = {
    bgUrl: null,
    bgEpoch: 0,
    visible: null,
    lastPose: {},
    line: null,
    emote: null,
};
